import * as _ from 'lodash';
import React from 'react';
import Loadable from 'react-loadable';
import { Switch } from 'react-router-dom';
import EditableRoute from '@components/EditableRoute';

import PageWrapper from './components/PageWrapper';
import PortalNotificationsPage from '@modules/appraisalAdmin/pages/ElectronicDeliveryRequestsPortalNotifications';
import PortalNotificationRecords from '@modules/appraisalAdmin/pages/ElectronicDeliveryRequestsPortalNotifications/records';
import JobDetails from '@modules/appraisalAdmin/pages/letterRuns/JobDetails';

const Loading = () => <div />;

const MassRecalculation = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/massRecalculation'),
  loading: Loading,
});

const RecalculationErrors = Loadable({
  loader: () => import('@modules/processManager/pages/RecalculationErrors'),
  loading: Loading,
});

const AppraisalRoll = Loadable({
  loader: () => import('@modules/processManager/pages/rollLog'),
  loading: Loading,
});

const TopTaxpayer = Loadable({
  loader: () => import('@modules/bi/pages/taxingUnitOptions'),
  loading: Loading,
});

const AppraisalTotals = Loadable({
  loader: () => import('@modules/bi/pages/appraisalTotalsTesting'),
  loading: Loading,
});

const AppraisalTotalsTesting = Loadable({
  loader: () => import('@modules/bi/pages/appraisalTotalsTesting'),
  loading: Loading,
});

const AppraisalNotices = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/AppraisalNotices'),
  loading: Loading,
});

const ElectronicDeliveryRequestsSignUpReminders = Loadable({
  loader: () =>
    import(
      '@modules/appraisalAdmin/pages/ElectronicDeliveryRequestsSignUpReminders'
    ),
  loading: Loading,
});

const CaptureSubmissionValues = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/CaptureSubmissionValues'),
  loading: Loading,
});

const PINRetrievalRequests = Loadable({
  loader: () => import('./pages/PINRetrievalRequests'),
  loading: Loading,
});

const MassCreateComp = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/MassCreateComp'),
  loading: Loading,
});

const MassGeneration = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/MassGeneration'),
  loading: Loading,
});

const MassDeletion = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/MassDeletion'),
  loading: Loading,
});

const RollCorrectionGroups = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/rollCorrectionManager'),
  loading: Loading,
});

const RollCorrectionGroup = Loadable({
  loader: () =>
    import('@modules/appraisalAdmin/pages/rollCorrectionManager/detail'),
  loading: Loading,
});

const RollCorrMoveOpenAppealHistory = Loadable({
  loader: () =>
    import(
      '@modules/appraisalAdmin/pages/rollCorrectionManager/moveOpenAppealHistory'
    ),
  loading: Loading,
});

const RollCorrMoveOpenAppeals = Loadable({
  loader: () =>
    import(
      '@modules/appraisalAdmin/pages/rollCorrectionManager/moveOpenAppeals'
    ),
  loading: Loading,
});

const RollCorrectionJobs = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/MassRollCorrect'),
  loading: Loading,
});

const OwnershipAgentExport = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/Exports/OwnershipAgent'),
  loading: Loading,
});

const AppraisalDataExport = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/Exports/AppraisalData'),
  loading: Loading,
});

const AppraisalBetaDataExport = Loadable({
  loader: () =>
    import('@modules/appraisalAdmin/pages/Exports/AppraisalBetaData'),
  loading: Loading,
});

const AppraisalDataExportDetail = Loadable({
  loader: () =>
    import('@modules/appraisalAdmin/pages/Exports/AppraisalData/Detail'),
  loading: Loading,
});

const AppraisalBetaDataExportDetail = Loadable({
  loader: () =>
    import('@modules/appraisalAdmin/pages/Exports/AppraisalBetaData/Detail'),
  loading: Loading,
});

const AppraisalDataExportJSON = Loadable({
  loader: () =>
    import('@modules/appraisalAdmin/pages/Exports/AppraisalDataJSON'),
  loading: Loading,
});

const AppraisalDataExportJSONDetail = Loadable({
  loader: () =>
    import('@modules/appraisalAdmin/pages/Exports/AppraisalDataJSON/Detail'),
  loading: Loading,
});

const BppRenditionExport = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/Exports/BppRendition'),
  loading: Loading,
});

const BppRenditionExportDetail = Loadable({
  loader: () =>
    import('@modules/appraisalAdmin/pages/Exports/BppRendition/Detail'),
  loading: Loading,
});

const PTDListing = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/Exports/PTDListing'),
  loading: Loading,
});

const ImportPdfDocuments = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/ImportPdfDocuments'),
  loading: Loading,
});

const MassFileImports = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/MassFileImports'),
  loading: Loading,
});

const MassUpdatePropertyBeta = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/MassUpdatePropertyBeta'),
  loading: Loading,
});

const MassUpdateOther = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/MassUpdateOther'),
  loading: Loading,
});

const TotalEstimate = Loadable({
  loader: () => import('@modules/processManager/pages/TotalEstimate'),
  loading: Loading,
});

const MineralImport = Loadable({
  loader: () => import('@modules/processManager/pages/MineralImport'),
  loading: Loading,
});

const MassImportExemptions = Loadable({
  loader: () => import('@modules/processManager/pages/MassImportExemptions'),
  loading: Loading,
});

const SalesImport = Loadable({
  loader: () => import('@modules/processManager/pages/SalesImport'),
  loading: Loading,
});

const CaptureJanuary1Owner = Loadable({
  loader: () => import('@modules/processManager/pages/CaptureJanuary1Owner'),
  loading: Loading,
});

const CaptureJanurary1OwnerDetail = Loadable({
  loader: () => import('./pages/CaptureJanuary1Owner/components/Details'),
  loading: Loading,
});

const AutoAddOV65 = Loadable({
  loader: () => import('@modules/processManager/pages/AutoAddOV65'),
  loading: Loading,
});

const TaxLimitationCurrentYear = Loadable({
  loader: () =>
    import('@modules/processManager/pages/TaxLimitationCurrentYear'),
  loading: Loading,
});

const TaxLimitationHITLAdjustment = Loadable({
  loader: () =>
    import('@modules/processManager/pages/TaxLimitationHITLAdjustment'),
  loading: Loading,
});

const TaxLimitationCompressionCalculation = Loadable({
  loader: () =>
    import('@modules/processManager/pages/TaxLimitationCompressionCalculation'),
  loading: Loading,
});

const TaxLimitationProcess = Loadable({
  loader: () => import('@modules/processManager/pages/TaxLimitationProcess'),
  loading: Loading,
});

const ReprintTotals = Loadable({
  loader: () => import('./pages/totalsLog'),
  loading: Loading,
});

const CertificationProcess = Loadable({
  loader: () => import('./pages/rollCertification'),
  loading: Loading,
});

const NewYearLayer = Loadable({
  loader: () => import('./pages/NewYearLayer'),
  loading: Loading,
});

const EarsSubmission = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/Exports/PTDListing'),
  loading: Loading,
});

const EptsSubmission = Loadable({
  loader: () => import('./pages/eptsSubmission'),
  loading: Loading,
});

const HSAuditExport = Loadable({
  loader: () => import('./pages/HSAuditExport'),
  loading: Loading,
});

const ProcessEx366 = Loadable({
  loader: () => import('./pages/processEx366'),
  loading: Loading,
});

const ProcessBPPLateFilePenalty = Loadable({
  loader: () => import('./pages/BPPPenaltyProcess'),
  loading: Loading,
});

const ProcessBPPLateFilePenaltyDetail = Loadable({
  loader: () => import('./pages/BPPPenaltyProcess/components/Detail'),
  loading: Loading,
});

const ProcessBPPLateFilePenaltyProperties = Loadable({
  loader: () => import('./pages/BPPPenaltyProcess/components/Properties'),
  loading: Loading,
});

const DeedProcessing = Loadable({
  loader: () => import('./pages/DeedProcessing'),
  loading: Loading,
});

const ExemptionReset = Loadable({
  loader: () => import('./pages/ExemptionReset'),
  loading: Loading,
});

const ExemptionResetDetail = Loadable({
  loader: () => import('./pages/ExemptionReset/components/Detail'),
  loading: Loading,
});

const IntegrityCheckListing = Loadable({
  loader: () => import('./pages/IntegrityCheck'),
  loading: Loading,
});

const IntegrityCheckDetail = Loadable({
  loader: () => import('./pages/IntegrityCheck/components/Detail'),
  loading: Loading,
});

const IntegrityCheckConfiguration = Loadable({
  loader: () => import('./pages/IntegrityCheckConfiguration'),
  loading: Loading,
});

const MassCassValidation = Loadable({
  loader: () => import('./pages/MassCassValidation/Main'),
  loading: Loading,
});

const MassMatchSalesWithDeeds = Loadable({
  loader: () => import('./pages/MassMatchSalesWithDeeds'),
  loading: Loading,
});

const MassUpdateSalesRuns = Loadable({
  loader: () => import('./pages/MassUpdateSalesRuns'),
  loading: Loading,
});

const MassCassValidationResults = Loadable({
  loader: () => import('./pages/MassCassValidation/Results'),
  loading: Loading,
});

const MassCassValidationCreate = Loadable({
  loader: () => import('./pages/MassCassValidation/CreateNewDialogue/index.js'),
  loading: Loading,
});

const PTDConfiguration = Loadable({
  loader: () => import('./pages/PTDConfiguration'),
  loading: Loading,
});

const PVSTaxRateSubmission = Loadable({
  loader: () => import('./pages/PVSTaxRateSubmission'),
  loading: Loading,
});

const BPPPenaltyConfiguration = Loadable({
  loader: () => import('./pages/BPPPenaltyConfiguration'),
  loading: Loading,
});

const BuildingPermitConfigurations = Loadable({
  loader: () => import('./pages/BuildingPermitConfigurations'),
  loading: Loading,
});

const BuildingPermitConfigurationDetail = Loadable({
  loader: () =>
    import('./pages/BuildingPermitConfigurations/components/Detail'),
  loading: Loading,
});

const BuildingPermitImportProcessDetail = Loadable({
  loader: () => import('./pages/BuildingPermitImportProcess/components/Detail'),
  loading: Loading,
});

const BuildingPermitImportProcess = Loadable({
  loader: () => import('./pages/BuildingPermitImportProcess'),
  loading: Loading,
});

const BuildingPermitMassDelete = Loadable({
  loader: () => import('./pages/BuildingPermitMassDelete'),
  loading: Loading,
});

const MassLetterRuns = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/letterRuns'),
  loading: Loading,
});

const MassGenerateLetters = Loadable({
  loader: () => import('./pages/MassLetterRuns'),
  loading: Loading,
});

const LetterMaintenance = Loadable({
  loader: () => import('./pages/LetterMaintenance/LandingPage'),
  loading: Loading,
});

const LetterEdit = Loadable({
  loader: () => import('./pages/LetterMaintenance/Edit'),
  loading: Loading,
});

export const prefix = '/appraisal-process-manager';

export const appRoutes = {};

export const pathToTitleAndComponent = {
  [prefix]: {
    component: MassRecalculation,
  },
  [`${prefix}/mass-recalc`]: {
    title: 'Mass Recalculation',
    component: MassRecalculation,
  },
  [`${prefix}/recalc-errors`]: {
    title: 'Recalculation Errors',
    component: RecalculationErrors,
  },
  [`${prefix}/appraisal-roll`]: {
    title: 'Appraisal Roll',
    component: AppraisalRoll,
  },
  [`${prefix}/top-taxpayer-report`]: {
    title: 'Top Taxpayer Report',
    component: TopTaxpayer,
  },
  [`${prefix}/tirz-property-report`]: {
    title: 'TIRZ Property Report',
    component: TopTaxpayer,
  },
  [`${prefix}/appraisal-totals`]: {
    title: 'Appraisal Totals',
    component: AppraisalTotals,
  },
  [`${prefix}/reprint-totals`]: {
    title: 'Appraisal Totals Reprint',
    component: ReprintTotals,
  },
  [`${prefix}/estimate-totals`]: {
    title: 'Appraisal Totals Estimate Run',
    component: TotalEstimate,
  },
  [`${prefix}/appraisal-notices`]: {
    component: AppraisalNotices,
  },
  [`${prefix}/capture-submission-values`]: {
    component: CaptureSubmissionValues,
  },
  [`${prefix}/pin-retrieval-requests`]: {
    component: PINRetrievalRequests,
  },
  [`${prefix}/mass-create-comp`]: {
    component: MassCreateComp,
  },
  [`${prefix}/mass-generation`]: {
    component: MassGeneration,
  },
  [`${prefix}/mass-deletion`]: {
    component: MassDeletion,
  },
  [`${prefix}/notice-process`]: {
    title: 'Appraisal Notice Process',
    component: Loading,
  },
  [`${prefix}/electronic-delivery-requests-sign-up-reminders`]: {
    title: 'Electronic Delivery Requests - Sign Up Reminders',
    component: ElectronicDeliveryRequestsSignUpReminders,
  },
  [`${prefix}/certification-process`]: {
    title: 'Certification Process',
    component: CertificationProcess,
  },
  [`${prefix}/new-year-layer`]: {
    title: 'New Year Layer',
    component: NewYearLayer,
  },
  [`${prefix}/ptd-process/integrity-checks`]: {
    title: 'PTD Integrity Checks',
    component: IntegrityCheckListing,
  },
  [`${prefix}/ptd-process/ears-submission`]: {
    title: 'EARS Submission',
    component: EarsSubmission,
  },
  [`${prefix}/ptd-process/epts-submission`]: {
    title: 'EPTS Submission',
    component: EptsSubmission,
  },
  [`${prefix}/ptd-process/ptd-configuration`]: {
    title: 'PTD Configuration',
    component: PTDConfiguration,
  },
  [`${prefix}/ptd-process/pvs-tax-rate-submission`]: {
    title: 'PVS Tax Rate Submission',
    component: PVSTaxRateSubmission,
  },
  [`${prefix}/roll-correction-groups`]: {
    component: RollCorrectionGroups,
  },
  [`${prefix}/roll-correction-groups/:rollCorrGroupID`]: {
    component: RollCorrectionGroup,
  },
  [`${prefix}/roll-correction-groups/:rollCorrGroupID/move-open-appeal-history`]:
    {
      component: RollCorrMoveOpenAppealHistory,
    },
  [`${prefix}/roll-correction-groups/:rollCorrGroupID/move-open-appeals`]: {
    component: RollCorrMoveOpenAppeals,
  },
  [`${prefix}/roll-correction-jobs`]: {
    component: RollCorrectionJobs,
  },
  [`${prefix}/exports/ownership-agent`]: {
    title: 'Ownership Agent Export',
    component: OwnershipAgentExport,
  },
  [`${prefix}/exports/appraisal-data`]: {
    title: 'Appraisal Data Export',
    component: AppraisalDataExport,
  },
  [`${prefix}/exports/appraisal-beta-data`]: {
    title: 'Appraisal Beta Data Export',
    component: AppraisalBetaDataExport,
  },
  [`${prefix}/exports/appraisal-data/:logID`]: {
    title: 'Appraisal Data Export Detail',
    component: AppraisalDataExportDetail,
  },
  [`${prefix}/exports/appraisal-beta-data/:runID`]: {
    title: 'Appraisal Beta Data Export Detail',
    component: AppraisalBetaDataExportDetail,
  },
  [`${prefix}/exports/appraisal-json`]: {
    title: 'Appraisal Data Export JSON',
    component: AppraisalDataExportJSON,
  },
  [`${prefix}/exports/appraisal-json/:logID`]: {
    title: 'Appraisal Data Export JSON Detail',
    component: AppraisalDataExportJSONDetail,
  },
  [`${prefix}/exports/bpp-rendition`]: {
    title: 'BPP Rendition Export',
    component: BppRenditionExport,
  },
  [`${prefix}/exports/bpp-rendition/:runID`]: {
    title: 'BPP Rendition Export Detail',
    component: BppRenditionExportDetail,
  },
  [`${prefix}/exports/ptd-listing`]: {
    title: 'PTD Listing',
    component: PTDListing,
  },
  [`${prefix}/import-pdf-documents`]: {
    component: ImportPdfDocuments,
  },
  [`${prefix}/mass-file-imports`]: {
    component: MassFileImports,
  },
  [`${prefix}/mass-update-property-beta`]: {
    component: MassUpdatePropertyBeta,
  },
  [`${prefix}/mass-update-other`]: {
    component: MassUpdateOther,
  },
  [`${prefix}/hs-audit-export`]: {
    title: 'HS Audit Export',
    component: HSAuditExport,
  },
  [`${prefix}/process-ex-366`]: {
    title: 'Process EX 366',
    component: ProcessEx366,
  },
  [`${prefix}/process-bpp-late-penalty`]: {
    title: 'BPP Late File Penalty Process',
    component: ProcessBPPLateFilePenalty,
  },
  [`${prefix}/process-bpp-late-penalty/:penaltyID`]: {
    title: 'BPP Late File Penalty Process',
    component: ProcessBPPLateFilePenaltyDetail,
  },
  [`${prefix}/process-bpp-late-penalty/:penaltyID/properties`]: {
    title: 'BPP Late File Penalty Process',
    component: ProcessBPPLateFilePenaltyProperties,
  },
  [`${prefix}/just-appraised/deed-processing`]: {
    title: 'Deed Processing',
    component: DeedProcessing,
  },
  [`${prefix}/mass-import-exemptions`]: {
    title: 'Mass Import Exemptions',
    component: MassImportExemptions,
  },
  [`${prefix}/mineral-import`]: {
    title: 'Mineral Vendor Import',
    component: MineralImport,
  },
  [`${prefix}/sales-import`]: {
    title: 'Sales Import',
    component: SalesImport,
  },
  [`${prefix}/capture-january1-owner`]: {
    title: 'Capture January 1 Owners',
    component: CaptureJanuary1Owner,
  },
  [`${prefix}/capture-january1-owner/:captureJanuary1OwnerID`]: {
    title: 'Capture January 1 Owners Process',
    component: CaptureJanurary1OwnerDetail,
  },
  [`${prefix}/auto-add-ov65`]: {
    title: 'Auto Add OV65',
    component: AutoAddOV65,
  },
  [`${prefix}/tax-limitation-current-year`]: {
    title: 'Tax Limitation (Current Year)',
    component: TaxLimitationCurrentYear,
  },
  [`${prefix}/tax-limitation-hitl-adjustment`]: {
    title: 'Tax Limitation (Homestead Increase Tax Limitation Adjustment)',
    component: TaxLimitationHITLAdjustment,
  },
  [`${prefix}/tax-limitation-compression-calculation`]: {
    title: 'Tax Limitation (Compression Calculation)',
    component: TaxLimitationCompressionCalculation,
  },
  [`${prefix}/tax-limitation-process`]: {
    title: 'Tax Limitation Process',
    component: TaxLimitationProcess,
  },
  [`${prefix}/exemption-resets`]: {
    title: 'Exemption Resets',
    component: ExemptionReset,
  },
  [`${prefix}/exemption-reset/:exemptionResetLogID`]: {
    title: 'Exemption Resets',
    component: ExemptionResetDetail,
  },
  [`${prefix}/integrity-checks`]: {
    title: 'Integrity Checks',
    component: IntegrityCheckListing,
  },
  [`${prefix}/integrity-checks/:integrityID`]: {
    title: 'Integrity Check Detail',
    component: IntegrityCheckDetail,
  },
  [`${prefix}/integrity-check-configuration`]: {
    title: 'Integrity Check Configuration',
    component: IntegrityCheckConfiguration,
  },
  [`${prefix}/mass-update-sales-runs`]: {
    title: 'Mass Update Sales Runs',
    component: MassUpdateSalesRuns,
  },
  [`${prefix}/mass-cass-validation`]: {
    title: 'Mass CASS Certification',
    component: MassCassValidation,
  },
  [`${prefix}/mass-match-sales-with-deeds`]: {
    title: 'Mass Match Sales with Deeds',
    component: MassMatchSalesWithDeeds,
  },
  [`${prefix}/mass-cass-validation/results/:runID`]: {
    title: 'Mass CASS Certification Results',
    component: MassCassValidationResults,
  },
  [`${prefix}/mass-cass-validation/create`]: {
    title: 'Mass CASS Certification Create',
    component: MassCassValidationCreate,
  },
  [`${prefix}/appraisal-totals-testing`]: {
    title: 'Appraisal Totals - Testing',
    component: AppraisalTotalsTesting,
  },
  [`${prefix}/bpp-penalty-configuration`]: {
    title: 'BPP Late File Penalty Process Configuration',
    component: BPPPenaltyConfiguration,
  },
  [`${prefix}/building-permit-configurations`]: {
    title: 'Building Permit Configurations',
    component: BuildingPermitConfigurations,
  },
  [`${prefix}/building-permit-configurations/:configID`]: {
    title: 'Building Permit Configuration Detail',
    component: BuildingPermitConfigurationDetail,
  },
  [`${prefix}/building-permit-import-process`]: {
    title: 'Building Permit Import Process',
    component: BuildingPermitImportProcess,
  },
  [`${prefix}/building-permit-import-process/:importID`]: {
    title: 'Building Permit Import Process Detail',
    component: BuildingPermitImportProcessDetail,
  },
  [`${prefix}/building-permit-mass-delete`]: {
    title: 'Building Permit Mass Delete',
    component: BuildingPermitMassDelete,
  },
  [`${prefix}/electronic-delivery-requests-portal-notifications`]: {
    title: 'Pending Portal Delivery Notifications',
    component: PortalNotificationsPage,
  },
  [`${prefix}/portal-notification-records/:runId`]: {
    component: PortalNotificationRecords,
  },
  [`${prefix}/mass-letter-runs/:jobId/details`]: {
    component: JobDetails,
  },
  ...appRoutes,
};

// Conditionally show mass letter runs if letter processing is enabled
if (process.env.LETTER_PROCESSING_ENABLED) {
  pathToTitleAndComponent[`${prefix}/mass-letter-runs`] = {
    title: 'Mass Letter Runs',
    component: MassLetterRuns,
  };
  pathToTitleAndComponent[`${prefix}/mass-letter-runs/create`] = {
    title: 'Mass Generate Letters',
    component: MassGenerateLetters,
  };
  pathToTitleAndComponent[`${prefix}/letter-maintenance`] = {
    title: 'Letter Maintenance',
    component: LetterMaintenance,
  };
  pathToTitleAndComponent[`${prefix}/letter-maintenance/create`] = {
    title: 'Letter Maintenance',
    component: LetterEdit,
  };
  pathToTitleAndComponent[`${prefix}/letter-maintenance/edit/:letterID`] = {
    title: 'Letter Maintenance',
    component: LetterEdit,
  };
}
export const parseHeaderTitle = (path) => {
  const paths = Object.keys(pathToTitleAndComponent);
  const currentPath = paths.find((p) => p !== prefix && path.startsWith(p)); // skip '/' route

  return _.get(pathToTitleAndComponent[currentPath], 'title', '');
};

const processManagerRoutes = (props) => (
  <PageWrapper {...props}>
    <Switch>
      {Object.entries(pathToTitleAndComponent).map(([path, { component }]) => (
        <EditableRoute exact key={path} path={path} component={component} />
      ))}
    </Switch>
  </PageWrapper>
);

export default processManagerRoutes;
